import React from "react";
import Help from "../../../../common/Help.jsx";

const MapboxHelpTooltip = ({description, className}) => {
    return <Help text={description} trigger="hover" className={`mapbox-help-container ${className ? className : ''}`} />
}

export default MapboxHelpTooltip;